export default __webpack_public_path__ + "static/media/s.036a0aae.jpg";